import React from 'react'
import PropTypes from 'prop-types'
import { Box, Chip, Typography } from '@material-ui/core'
import {
  AlertTriangle as AlertTriangleIcon,
  Search as SearchIcon,
} from 'react-feather'

import FilenameChip from '../../../../../FilenameChip'

import constants from 'constants/index'
import useStyles from './styles'

const FindingCard = ({ finding }) => {
  const { SPECIALIST_LABEL } = constants.dai.disputes

  const classes = useStyles()

  const specialistLabel =
    SPECIALIST_LABEL[finding.specialist] || finding.specialist

  return (
    <Box className={classes.findingCard}>
      <Box className={classes.findingTitle}>
        <SearchIcon size={14} />
        <Typography className={classes.findingTitleText}>
          {specialistLabel}
        </Typography>
        {finding.ds010_disqualifies_evidence && (
          <Chip
            size="small"
            icon={<AlertTriangleIcon size={10} />}
            label="Desclassifica evidência"
            className={classes.disqualifiedBadge}
          />
        )}
      </Box>

      {finding.what_was_sought && (
        <>
          <Typography className={classes.findingSubLabel}>
            O que foi buscado
          </Typography>
          <Typography className={classes.findingText}>
            {finding.what_was_sought}
          </Typography>
        </>
      )}

      {finding.what_was_found && (
        <>
          <Typography className={classes.findingSubLabel}>
            O que foi encontrado
          </Typography>
          <Typography className={classes.findingText}>
            {finding.what_was_found}
          </Typography>
        </>
      )}

      {finding.where_found && (
        <>
          <Typography className={classes.findingSubLabel}>Onde</Typography>
          <Typography className={classes.findingText}>
            {finding.where_found}
          </Typography>
        </>
      )}

      {finding.implication && (
        <>
          <Typography className={classes.findingSubLabel}>
            Implicação
          </Typography>
          <Typography className={classes.findingText}>
            {finding.implication}
          </Typography>
        </>
      )}

      {finding.disqualified_file && (
        <>
          <Typography className={classes.findingSubLabel}>
            Arquivo desclassificado
          </Typography>
          <Box className={classes.evidencesRow}>
            <FilenameChip filename={finding.disqualified_file} />
          </Box>
        </>
      )}
    </Box>
  )
}

FindingCard.propTypes = {
  finding: PropTypes.object.isRequired,
}

export default FindingCard
